import accessLocalStorage from './accessLocalStorage';

export const INVALID_SESSION_RESPONSE_MESSAGE =
  'O servidor devolveu uma resposta inválida. A sessão atual foi mantida.';

export const SESSION_WRITE_FAILURE_MESSAGE =
  'Não foi possível gravar a sessão no navegador.';

export const REJECTED_CREDENTIAL_STATUS = 401;

const MASTER_TENANT = 'vgs';

const isPlainObject = (value) => !!value && typeof value === 'object' && !Array.isArray(value);

export const isValidSession = (session) =>
  isPlainObject(session)
  && typeof session.token === 'string'
  && session.token !== ''
  && isPlainObject(session.user)
  && typeof session.user.idtenant === 'string'
  && session.user.idtenant !== '';

export const buildSession = (session, ipRequest) => ({
  token: session.token,
  user: session.user,
  ipRequest,
});

export const decodeJwtPayload = (token) => {
  if (typeof token !== 'string') return null;
  const parts = token.split('.');
  if (parts.length < 2) return null;
  try {
    const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
    return isPlainObject(payload) ? payload : null;
  } catch (_e) {
    return null;
  }
};

export const isImpersonatingFromMaster = (session) => {
  if (!isValidSession(session)) return false;
  const payload = decodeJwtPayload(session.token);
  return !!payload && payload.impersonated === true && payload.realTenant === MASTER_TENANT;
};

export const expireSession = () => {
  accessLocalStorage.removeUserItem();
  window.location.href = '/';
};
